import { AnyAction } from 'redux';

import { stationsActions } from '../reducer';

export const resetSelectedStationOnRoute = (): AnyAction => stationsActions.resetSelectedStation();
